import React, { ReactNode } from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

interface Props {
  children: ReactNode
  title: string
  description: string
  isChecked: boolean
  setIsChecked: () => void
}

const Option = ({ children, title, description, isChecked, setIsChecked }: Props) => {
  return (
    <Box
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
    >
      <Box
        gap="s12"
        padding="s16"
        background="grey000White"
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: `${isChecked ? 'viridian1000' : 'grey400'}`,
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
        onClick={setIsChecked}
      >
        <Box flexDirection="row" justifyContent="spaceBetween" style={{ width: '100%' }}>
          <Text.Normal weight="medium" color="grey800">
            {title}
          </Text.Normal>
          <Box
            flexDirection="row"
            alignItems="center"
            alignSelf="center"
            background={isChecked ? 'viridian1000' : 'grey000White'}
            border={{
              all: {
                width: 's2',
                style: 'solid',
                color: `${isChecked ? 'viridian1000' : 'grey400'}`,
              },
            }}
            borderRadius={{
              all: 'abs100',
            }}
          >
            <Icon.Medium icon="check" color="grey000White" />
          </Box>
        </Box>
        <Text.Normal>{description}</Text.Normal>
      </Box>
      {isChecked && children}
    </Box>
  )
}

export default Option
